import React, { useEffect, useState, useRef, useCallback } from "react";
import "./Managequery.scss";
import Select from "react-select";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import { RpaServices } from "../services/RpaServices";
import { CircularProgress } from "@mui/material";
import CustomPagination from "../utils/paginationUtils";
import { HospitalServices } from "../services/HospitalServices";
import SearchIcon from "../assets/searchIconGreen.svg";
import CloseIcon from "../assets/crossIcon.svg";
import { useFormik } from "formik";
import EditStatusModal from "../dashboard/cases/editCases/EditStatusModal";
import DeleteIcon from "../assets/deleteIconBlack.svg";
import TmsQueries from "../dashboard/cases/TmsQueries";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import { getUser } from "../config/user";
import QueryForwardDoctorModal from "../dashboard/cases/QueryForwardtoDoctorModal.jsx/QueryForwardDoctorModal";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { ReactComponent as NurseIcon } from "../assets/NurseIcon.svg";
import { ReactComponent as DoubleForwardArrow } from "../assets/DoubleForwardArrow.svg";
import { ReactComponent as CopyIcon } from "../assets/Copy.svg";
import { toast } from "react-toastify";
import CountdownTimer from "../utils/countDownTimer";
import { ReportServices } from "../services/ReportServices";
import { InterUserMangementServices } from "../services/InternalUserMangementServices";

const INACTIVITY_TIMEOUT = 5 * 60 * 1000;
function Managequery() {
  const [queryData, setQueryData] = useState([]);
  const [totalPages, setTotalPages] = useState(10);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [hospitalInput, setHospitalInput] = useState("");
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [caseId, setCaseId] = useState(null);
  const [hospitalList, setHospitalList] = useState([]);
  const [hospitalId, setHospitalId] = useState("");
  const [queryCount, setQueryCount] = useState(0);
  const [selectedQueryType, setSelectedQueryType] = useState("");
  const [searchField, setSearchField] = useState("patientname");
  const [searchValue, setSearchValue] = useState("");

  const [caseQueryCounts, setCaseQueryCounts] = useState({
    admissionQueryCount: 0,
    enhancementQueryCount: 0,
    claimQueryCount: 0,
  });
  const [myQueryCounts, setMyQuryCounts] = useState({
    admissionQueryCount: 0,
    enhancementQueryCount: 0,
    claimQueryCount: 0,
  });

  const [expandedMessages, setExpandedMessages] = useState({});
  const [copiedMessageId, setCopiedMessageId] = useState(null);
  const [isForwardDoctorOpen, setIsForwardDoctorOpen] = useState(false);
  const [forwardQueryId, setForwardQueryId] = useState(null);
  const [reassignOpenId, setReassignOpenId] = useState(null);
  const [reassignOpenUpById, setReassignOpenUpById] = useState({});
  const [reassignUsersByQueryId, setReassignUsersByQueryId] = useState({});
  const [reassignLoadingId, setReassignLoadingId] = useState(null);
  const [usersMap, setUsersMap] = useState(null);
  // const [usersMap, setUsersMap] = useState(null);
  const [unblurQueryIds, setUnblurQueryIds] = useState({});
  const [, setTick] = useState(0);

  const user = getUser();
  const myUserId = user?.user?.id ?? user?.id;
  let searchTimeRef = useRef();
  const selectedQueryLoadedRef = useRef(false);
  const skipSelectedQueryEffectFetchRef = useRef(false);
  const forwardDoctorLoadedRef = useRef(false);
  const inactivityTimerRef = useRef(null);
  useEffect(() => {
    ReportServices.getUsers()
      .then((res) => setUsersMap(res?.data?.users ?? null))
      .catch(() => {});
  }, []);

  // Search field options for dropdown
  const searchFieldOptions = [
    { value: "pmjayId", label: "PMJAY ID" },
    { value: "patientName", label: "Patient Name" },
  ];

  const formik = useFormik({
    initialValues: {
      name: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.name) {
        errors.name = "Hospital name is required";
      }
      return errors;
    },
    onSubmit: (values) => {},
  });

  const getWipTimer = (wipAt) => {
    if (!wipAt) return "00:00:00";
    const seconds = Math.max(
      0,
      Math.floor((Date.now() - new Date(wipAt)) / 1000),
    );
    const h = String(Math.floor(seconds / 3600)).padStart(2, "0");
    const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");
    return `${h}:${m}:${s}`;
  };

  const getNameByUserId = (users, userId) => {
    if (!userId) return "";
    if (users && !Array.isArray(users)) {
      return users[String(userId)] || "";
    }
    const found = (users || []).find(
      (item) => String(item?.userId ?? item?.id) === String(userId),
    );
    return found?.fullName || found?.user?.fullName || "";
  };

  const getTeamUserDisplayName = (item) => {
    const id = item?.userId || item?.id;
    return getNameByUserId(usersMap, id) || item?.fullName || "Name";
  };

  const getReassignTeamUsers = async () => {
    const res = await InterUserMangementServices.getDutTeamUsers({
      limit: 100,
      page: 1,
    });
    return (res?.data?.teamUsers || []).map((item) => ({
      ...item,
      userId: item.userId || item.id,
      user: item.user || item,
    }));
  };

  const isInternalAdmin = (item) => {
    const fullName = item?.user?.fullName ?? item?.fullName ?? "";
    const roleName =
      item?.user?.roleName ??
      item?.roleName ??
      item?.roles?.[0]?.role?.roleName ??
      "";

    return (
      fullName.toLowerCase().replace(/\s/g, "") === "internaladmin" ||
      roleName.toLowerCase().replace(/\s/g, "") === "internaladmin"
    );
  };

  // function formatDateTime(dateStr) {
  //   if (!dateStr) return "";
  //   const date = new Date(dateStr);
  //   const day = String(date.getDate()).padStart(2, "0");
  //   const month = String(date.getMonth() + 1).padStart(2, "0");
  //   const year = date.getFullYear();
  //   let hours = date.getHours();
  //   const minutes = String(date.getMinutes()).padStart(2, "0");
  //   const seconds = String(date.getSeconds()).padStart(2, "0");
  //   const ampm = hours >= 12 ? "PM" : "AM";
  //   hours = hours % 12 || 12;

  //   return (
  //     <>
  //       {`${day}-${month}-${year}`}
  //       <br />
  //       {`${hours}:${minutes}:${seconds} ${ampm}`}
  //     </>
  //   );
  // }

  function formatDateTime(dateStr) {
    if (!dateStr) return "";

    const date = new Date(dateStr);

    const formattedDate = date.toLocaleDateString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    const formattedTime = date.toLocaleTimeString("en-IN", {
      timeZone: "Asia/Kolkata",
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    return (
      <>
        {formattedDate}
        <br />
        {formattedTime}
      </>
    );
  }

  const fetchQueries = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await RpaServices.manageQueries(
        "ACTIVE",
        page,
        10,
        searchValue,
        hospitalId,
        selectedQueryType?.includes("myQuery") ? "" : selectedQueryType,
        "",
        "",
        false,
        selectedQueryType?.includes("myQuery") ? user?.user?.id : "",
      );
      console.log("MANAGE QUERIES API ---->", response?.data?.queries);
      if (Array.isArray(response.data.queries)) {
        const formattedData = response.data.queries.map((query) => {
          const isWip = query?.wip || query?.isWip || false;
          const assignedTo = query?.case?.currentSubMasterStage?.assignedTo;
          const assignId = assignedTo || query?.wipTo;
          // const assignedTo = query?.case?.currentSubMasterStage?.assignedTo;
          // const assignId = assignedTo || query?.wipTo;

          return {
            case: query?.case,
            id: query.id,
            patientName: query.case.patient.patientName,
            hospitalId: query?.case?.hospital?.code,
            hospitalName: query?.case?.hospital?.name,
            pmjayId: query.case.pmjayId,
            tmsStageUpdateTime: query?.tmsStageUpdateTime,
            registeredDate: query?.case?.patient?.registeredDate,
            pmjayRegistrationId: query.case.pmjayRegistrationId,
            status: query.status,
            queryMessage: query.queryMessage,
            caseId: query?.case?.id,
            resolveTatTime: query?.deadline,
            commandCenterStage:
              query?.case?.currentSubMasterStage?.commandCenterStage,
            commandCenterStageId: query?.case?.currentSubMasterStage?.id,
            wipTo: assignId,
            wipTo: assignId,
            wipAt: query?.wipAt,
            doctorName: query?.wipToName || getNameByUserId(usersMap, assignId),
            doctorName: query?.wipToName || getNameByUserId(usersMap, assignId),
            wip: isWip,
          };
        });

        let coordinatorUsers = null;
        const usersByQueryId = {};

        for (const item of formattedData) {
          if (!item.wipTo || item.doctorName) {
            continue;
          }

          const nameFromUsers = getNameByUserId(usersMap, item.wipTo);
          // const nameFromUsers = getNameByUserId(usersMap, item.wipTo);
          if (nameFromUsers) {
            item.doctorName = nameFromUsers;
            continue;
          }

          if (!coordinatorUsers) {
            try {
              coordinatorUsers = await getReassignTeamUsers();
            } catch {
              coordinatorUsers = [];
            }
          }

          usersByQueryId[item.id] = coordinatorUsers;
          item.doctorName = getNameByUserId(
            usersByQueryId[item.id],
            item.wipTo,
          );
        }

        setReassignUsersByQueryId((prev) => ({ ...prev, ...usersByQueryId }));
        setQueryData(formattedData);
        setQueryCount(response.data.total);
        setTotalPages(response.data.totalPages || 1);
      } else {
        console.error("Queries data is not an array:", response.data.queries);
      }
    } catch (error) {
      handleApiErrorResponses(error);
    } finally {
      setIsLoading(false);
    }
  }, [
    page,
    hospitalInput,
    hospitalId,
    selectedQueryType,
    searchValue,
    searchField,
    usersMap,
    usersMap,
  ]);

  const handleQueryTypeChange = (type) => {
    setSelectedQueryType(type);
    setPage(1);
  };

  const getHospitalList = async () => {
    try {
      const response = await HospitalServices.gethospitals("", 1, 1500);
      setHospitalList(response.data.list);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const fetchCaseQueryCounts = useCallback(async () => {
    try {
      const response = await RpaServices.getCaseQueryCounts(
        hospitalId,
        "",
        false,
      );
      let { admissionQueryCount, enhancementQueryCount, claimQueryCount } =
        response.data;
      setCaseQueryCounts({
        admissionQueryCount,
        enhancementQueryCount,
        claimQueryCount,
      });
      const myQuery = await RpaServices.getCaseQueryCounts(
        hospitalId,
        "",
        false,
        user?.user?.id,
      );
      //  { admissionQueryCount, enhancementQueryCount, claimQueryCount } =
      //   myQuery.data;
      setMyQuryCounts({
        admissionQueryCount: myQuery?.data?.admissionQueryCount,
        enhancementQueryCount: myQuery?.data?.enhancementQueryCount,
        claimQueryCount: myQuery?.data?.claimQueryCount,
      });
    } catch (error) {
      handleApiErrorResponses(error);
    }
  }, [hospitalId, selectedQueryType]);

  const resetInactivityTimer = useCallback(() => {
    if (inactivityTimerRef.current) {
      clearTimeout(inactivityTimerRef.current);
    }
    inactivityTimerRef.current = setTimeout(() => {
      fetchQueries();
      fetchCaseQueryCounts();
    }, INACTIVITY_TIMEOUT);
  }, [fetchQueries, fetchCaseQueryCounts]);

  useEffect(() => {
    fetchCaseQueryCounts();
  }, [hospitalId, selectedQueryType]);

  useEffect(() => {
    fetchQueries();
  }, [
    page,
    hospitalInput,
    hospitalId,
    selectedQueryType,
    searchValue,
    searchField,
  ]);
  useEffect(() => {
    const activityEvents = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart",
      "click",
    ];

    activityEvents.forEach((event) =>
      window.addEventListener(event, resetInactivityTimer),
    );
    resetInactivityTimer(); // Start the timer on mount

    return () => {
      activityEvents.forEach((event) =>
        window.removeEventListener(event, resetInactivityTimer),
      );
      if (inactivityTimerRef.current) {
        clearTimeout(inactivityTimerRef.current);
      }
    };
  }, [resetInactivityTimer]);

  useEffect(() => {
    getHospitalList();
  }, []);

  useEffect(() => {
    if (reassignOpenId) return undefined;
    const timer = setInterval(() => setTick((count) => count + 1), 1000);
    return () => clearInterval(timer);
  }, [reassignOpenId]);

  useEffect(() => {
    const closeDropdown = () => setReassignOpenId(null);
    document.addEventListener("click", closeDropdown);
    return () => document.removeEventListener("click", closeDropdown);
  }, []);

  const handleReassignClick = async (query, e) => {
    e?.stopPropagation?.();
    e?.stopPropagation?.();
    if (reassignOpenId === query.id) {
      setReassignOpenId(null);
      return;
    }

    const rect = e?.currentTarget?.getBoundingClientRect?.();
    const spaceBelow = rect ? window.innerHeight - rect.bottom : 0;
    const spaceAbove = rect ? rect.top : 0;
    const estimatedDropdownHeight = 210;
    const shouldOpenUp =
      spaceBelow < estimatedDropdownHeight && spaceAbove > spaceBelow;

    setReassignOpenUpById((prev) => ({ ...prev, [query.id]: shouldOpenUp }));
    setReassignOpenId(query.id);

    if ((reassignUsersByQueryId[query.id] || []).length > 0) return;

    try {
      setReassignLoadingId(query.id);
      const users = await getReassignTeamUsers();
      setReassignUsersByQueryId((prev) => ({
        ...prev,
        [query.id]: users,
      }));
    } catch (error) {
      handleApiErrorResponses(error);
    } finally {
      setReassignLoadingId(null);
    }
  };

  const assignCaseStageForQuery = async (query, userId, reAssign = true) => {
    if (!query?.commandCenterStageId || !userId) return;

    const response = await ReportServices.assignCaseStage(
      query.commandCenterStageId,
      userId,
      reAssign,
    );
  };

  const handleReassignUserPick = async (query, selectedUser) => {
    const wipTo =
      selectedUser?.userId || selectedUser?.user?.id || selectedUser?.id;
    if (!query?.id || !wipTo) return;

    try {
      // const response = await RpaServices.wipAssignCaseQuery(
      //   query.id,
      //   wipTo,
      //   true,
      // );
      const response = await assignCaseStageForQuery(query, wipTo, true);
      if (response?.data?.message) toast.success(response.data.message);
      await fetchQueries();
      await fetchCaseQueryCounts();
      setQueryData((list) =>
        list.map((item) =>
          item.id === query.id
            ? {
                ...item,
                wip: true,
                wipTo,
                wipAt: new Date().toISOString(),
                doctorName:
                  getTeamUserDisplayName(selectedUser) || item.doctorName,
              }
            : item,
        ),
      );
      setReassignOpenId(null);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  // const handleProceedClick = async (query) => {
  //   // if (query?.caseId && !query?.wip)
  //   if (query?.caseId) {
  //     const canOpenQuery =
  //       !query.wip || String(query.wipTo) === String(myUserId);
  //     if (!canOpenQuery) return;

  //     if (query.id && myUserId) {
  //       try {
  //         const response = await RpaServices.wipAssignCaseQuery(
  //           query.id,
  //           myUserId,
  //           false,
  //         );
  //         if (response?.data?.message) toast.success(response.data.message);
  //       } catch (error) {
  //         handleApiErrorResponses(error);
  //         return;
  //       }
  //     }

  //     setSelectedQuery(query);
  //     setCaseId(query?.caseId);

  //     fetchQueries();
  //   }
  // };

  const handleProceedClick = async (query) => {
    if (!query?.caseId) return;

    const isOwner = String(query.wipTo) === String(myUserId);
    const isFree = !query.wip;

    // allow open if:
    // - not wip OR
    // - current user is owner
    if (!isFree && !isOwner) return;

    try {
      // only re-assign if needed
      if (query.id && myUserId && !isOwner) {
        await RpaServices.wipAssignCaseQuery(query.id, myUserId, false);
        await assignCaseStageForQuery(query, myUserId, false);
      }

      setSelectedQuery(query);
      setCaseId(query.caseId);

      // fetchQueries(); // refresh list
      await fetchCaseQueryCounts();
    } catch (error) {
      await fetchQueries(); // In case query is assigned to other user call this API
      handleApiErrorResponses(error);

      // IMPORTANT: still allow modal if user is owner
      if (isOwner) {
        setSelectedQuery(query);
        setCaseId(query.caseId);
      }
    }
  };

  const handleForwardDoctorClick = (query) => {
    if (query.wip && String(query.wipTo) !== String(myUserId)) return;
    setForwardQueryId(query?.id ?? null);
    setIsForwardDoctorOpen(true);
  };

  const handleCloseQueryModal = () => {
    setSelectedQuery(null);
  };

  useEffect(() => {
    if (!selectedQueryLoadedRef.current) {
      selectedQueryLoadedRef.current = true;
      return;
    }
    if (!selectedQuery) {
      if (skipSelectedQueryEffectFetchRef.current) {
        skipSelectedQueryEffectFetchRef.current = false;
        return;
      }
      fetchQueries();
    }
  }, [selectedQuery]);

  useEffect(() => {
    if (!forwardDoctorLoadedRef.current) {
      forwardDoctorLoadedRef.current = true;
      return;
    }
    if (!isForwardDoctorOpen) {
      fetchQueries();
    }
  }, [isForwardDoctorOpen]);

  const handleSearch = (e) => {
    const value = e.target.value.trimStart();

    if (searchTimeRef.current) {
      clearTimeout(searchTimeRef.current);
    }

    searchTimeRef.current = setTimeout(() => {
      const trimmedValue = value.trim();

      // allow empty OR more than 2 characters
      if (trimmedValue === "" || trimmedValue.length > 2) {
        setSearchValue(trimmedValue);
      }
    }, 500);
  };

  const handleDelete = async (queryId) => {
    if (!window.confirm("Are you sure you want to delete this query?")) return;
    try {
      await RpaServices.updateTmsQueriesStatus([queryId], "INACTIVE");
      setQueryData((prev) => prev.filter((q) => q.id !== queryId));
      setQueryCount((prev) => prev - 1);
      fetchCaseQueryCounts();
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const toggleMessageExpansion = (queryId) => {
    setExpandedMessages((prev) => ({
      ...prev,
      [queryId]: !prev[queryId],
    }));
  };

  const copyToClipboard = async (text, queryId) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedMessageId(queryId);
      setTimeout(() => setCopiedMessageId(null), 2000);
      toast.success("Query copied successfully");
    } catch (err) {
      console.error("Failed to copy:", err);
      alert("Failed to copy to clipboard");
    }
  };

  const renderQueryMessage = (query) => {
    const fullText = query?.queryMessage || "";
    if (!fullText) return "-";

    const words = fullText.split(/\s+/);

    // show first 5–6 words initially
    const previewWords = words.slice(0, 6).join(" ");
    const hasMore = words.length > 6;
    const isExpanded = expandedMessages[query.id];

    return (
      <div className="flex items-start justify-between">
        <div className="flex-1 pr-2 min-w-0">
          {isExpanded ? (
            <>
              {fullText
                .split("\n")
                .filter(Boolean)
                .map((msg, idx) => (
                  <div
                    key={idx}
                    className="mb-1 text-[14px] font-[Lufga] leading-[150%]"
                  >
                    {idx + 1}) {msg}
                  </div>
                ))}

              <span
                onClick={() => toggleMessageExpansion(query.id)}
                className="text-[#017C57] cursor-pointer text-[14px] font-medium hover:opacity-70 mt-1 inline-block"
              >
                Show Less
              </span>
            </>
          ) : (
            <div className="flex items-start justify-between">
              <div className="flex items-start flex-wrap">
                <span className="text-[14px] font-[Lufga] leading-[150%] break-words">
                  {previewWords}
                  {hasMore && "..."}
                </span>

                {hasMore && (
                  <span
                    onClick={() => toggleMessageExpansion(query.id)}
                    className="ml-1 text-[#017C57] cursor-pointer text-[14px] font-medium hover:opacity-70 whitespace-nowrap"
                  >
                    showmore
                  </span>
                )}
              </div>
              <button
                type="button"
                onClick={() => copyToClipboard(fullText, query.id)}
                className="ml-2 shrink-0 bg-transparent border-none outline-none p-0 cursor-pointer"
                title="Copy Full Query"
              >
                <CopyIcon className="w-5 h-5 pointer-events-none" />
              </button>
            </div>
          )}
        </div>
      </div>
    );
  };
  const getRemainingDays = (deadline) => {
    if (!deadline) return "-";

    const now = new Date();
    const end = new Date(deadline);

    const diffTime = end - now; // milliseconds
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays >= 0 ? `${diffDays} days` : "Expired";
  };
  return (
    <div className="manage-querybox">
      <span className="pathline">
        <WidgetsOutlinedIcon style={{ marginTop: "3px" }} /> &nbsp;
        &nbsp;/&nbsp; &nbsp; Dashboard &nbsp; &nbsp;/ &nbsp; &nbsp; Manage query
      </span>

      <div className="flex items-start mb-4">
        <h2>Manage Query ({queryCount})</h2>
        <div className="flex gap-3 items-center ml-auto">
          {/* <div className="px-4 py-2 rounded-full border border-solid border-green-700 bg-white min-w-[160px]">
            <Select
              options={searchFieldOptions}
              value={searchFieldOptions.find(
                (opt) => opt.value === searchField,
              )}
              onChange={(option) => {
                setSearchField(option.value);
                setSearchValue("");
              }}
              placeholder="Search By"
            />
          </div> */}

          <div className="flex items-center gap-2 px-4 py-4 rounded-full border border-solid border-green-700 bg-white w-[390px] flex-shrink-0">
            {" "}
            <img src={SearchIcon} alt="search-icon" className="w-4 h-4" />
            <input
              type="text"
              className="outline-none border-none w-full min-w-0 bg-transparent text-green-700 placeholder:text-green-700"
              onChange={handleSearch}
              placeholder={`Search by registration ID, patient name, hospital name`}
            />
          </div>
        </div>
      </div>

      <div className="flex gap-4 mb-4 items-center flex-nowrap">
        <button
          type="button"
          className={`h-14 w-[180px] flex items-center justify-center text-xs 2xl:text-sm rounded-full font-[Lufga] border-2 transition-all whitespace-nowrap border-solid
            ${
              selectedQueryType === ""
                ? "bg-[#017C57] text-white border-[#017C57]"
                : "bg-white text-[#017C57] border-[#017C57] hover:bg-[#017C57] hover:text-white"
            }`}
          onClick={() => handleQueryTypeChange("")}
        >
          All (
          {caseQueryCounts?.admissionQueryCount +
            caseQueryCounts?.enhancementQueryCount +
            caseQueryCounts?.claimQueryCount}
          )
        </button>
        {["admission", "enhancement", "claim"].map((type) => (
          <button
            key={type}
            type="button"
            className={`h-14 w-[200px] flex items-center justify-center text-xs 2xl:text-sm rounded-full font-[Lufga] border-2 transition-all whitespace-nowrap border-solid
              ${
                selectedQueryType === type
                  ? "bg-[#017C57] text-white border-[#017C57]"
                  : "bg-white text-[#017C57] border-[#017C57] hover:bg-[#017C57] hover:text-white"
              }`}
            onClick={() => handleQueryTypeChange(type)}
          >
            {type.charAt(0).toUpperCase() + type.slice(1)} (
            {caseQueryCounts[`${type}QueryCount`] || 0})
          </button>
        ))}

        <button
          type="button"
          className={`h-14 w-[180px] flex items-center justify-center text-xs 2xl:text-sm rounded-full font-[Lufga] border-2 transition-all whitespace-nowrap border-solid
            ${
              selectedQueryType === "myQuery"
                ? "bg-[#017C57] text-white border-[#017C57]"
                : "bg-white text-[#017C57] border-[#017C57] hover:bg-[#017C57] hover:text-white"
            }`}
          onClick={() => handleQueryTypeChange("myQuery")} // onClick={async () => {
          //   await fetchCaseQueryCounts(); //told by Chaitanya sir
          //   setSelectedQueryType("myQuery");
          // }}
        >
          My Queries (
          {myQueryCounts?.admissionQueryCount +
            myQueryCounts?.enhancementQueryCount +
            myQueryCounts?.claimQueryCount}
          )
        </button>
        {/* 
        <div
          className="ml-auto px-4 py-2 rounded-full bg-white min-w-[260px] border-solid"
          style={{ border: "2px solid #017C57" }}
        >
          <Select
            name="hospitalId"
            isClearable
            options={hospitalList}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            onChange={(item) => setHospitalId(item ? item.id : "")}
            value={hospitalList.find((item) => item.id === hospitalId) || null}
            placeholder="HOSPITAL NAME"
            menuPortalTarget={document.body}
            menuPosition="fixed"
            styles={{
              control: (base) => ({
                ...base,
                border: "none",
                boxShadow: "none",
                minHeight: "unset",
              }),
              singleValue: (base) => ({ ...base, color: "#017C57" }),
              placeholder: (base) => ({ ...base, color: "#017C57" }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              indicatorSeparator: () => ({ display: "none" }),
            }}
          />
        </div> */}
      </div>
      <div className="border-t border-b-0  border-solid border-[#E8E8E8] my-6" />

      <div className="w-full overflow-x-auto">
        <div className="w-full">
          <div className="query-list">
            {isLoading ? (
              <div className="w-full h-full flex justify-center items-center">
                <CircularProgress />
              </div>
            ) : queryData.length > 0 ? (
              <section className="mt-1 w-full">
                <div className="w-full rounded-[16px] border border-[#E5E5E5] bg-white">
                  {/* Header */}
                  <div className="text-sm grid grid-cols-[1fr_1.2fr_2fr_1fr_1fr_1fr_1.8fr] gap-2 2xl:gap-5 px-6 py-5 font-[Lufga] font-medium text-[#191919] text-[14px]">
                    <div>Patient</div>
                    {/* <div>Hospital Name</div>
                    <div>Hospital ID</div> */}
                    <div>Registration ID</div>
                    <div className="text-center ">Query</div>
                    <div>Query Due</div>

                    <div>Resolve TAT</div>
                    <div>Assign to</div>

                    <div className="text-center">Action</div>
                  </div>

                  {queryData.map((query, idx) => {
                    const isUnblurred = unblurQueryIds[query.id];
                    const showBlurBox =
                      query.wipTo && String(query.wipTo) !== String(myUserId);
                    const hideData = showBlurBox && !isUnblurred;
                    const showReassignButton = isInternalAdmin(user);
                    const shouldOpenUp = !!reassignOpenUpById[query.id];

                    return (
                      <div
                        key={query.id || idx}
                        className={`text-xs grid grid-cols-[1fr_1.2fr_2fr_1fr_1fr_1fr_1.8fr] gap-2 2xl:gap-5 px-6 py-6 items-center font-[Lufga] overflow-visible
              ${idx % 2 === 0 ? "bg-white" : "bg-[#FAFAFA]"}
              ${reassignOpenId === query.id ? "relative z-50" : "relative"}`}
                      >
                        <div className={hideData ? "blur-[10px]" : ""}>
                          {query.patientName}
                        </div>
                        {/* 
                      <div className="text-[16px]">{query.hospitalName}</div>
                      <div className="text-[16px]">{query.hospitalId}</div> */}

                        <div
                          className={
                            hideData
                              ? "whitespace-nowrap blur-[10px]"
                              : "whitespace-nowrap"
                          }
                        >
                          {query.pmjayRegistrationId || query.pmjayId}
                        </div>

                        <div className="min-w-0 relative overflow-visible">
                          <div className={hideData ? "blur-[10px]" : ""}>
                            {renderQueryMessage(query)}
                          </div>

                          {showBlurBox && (
                            <div className="absolute inset-0 z-10 grid grid-cols-[16px_72px_64px_108px] xl:grid-cols-[18px_84px_76px_112px] 2xl:grid-cols-[18px_96px_82px_117px] min-[1920px]:grid-cols-[18px_110px_88px_117px] items-center gap-2 whitespace-nowrap text-[#191919]">
                              <button
                                type="button"
                                className="bg-transparent border-none p-0 cursor-pointer flex items-center justify-center"
                                onClick={() => {
                                  // setUnblurQueryIds((prev) => ({
                                  //   ...prev,
                                  //   [query.id]: !prev[query.id],
                                  // }));
                                }}
                              >
                                <VisibilityOffOutlinedIcon className="!w-4 !h-4 shrink-0" />
                              </button>
                              <span
                                className="whitespace-normal break-normal text-[12px] font-semibold leading-[14px]"
                                title={
                                  query.doctorName ||
                                  getNameByUserId(usersMap, query.wipTo) ||
                                  "Assigned"
                                }
                              >
                                {query.doctorName ||
                                  getNameByUserId(usersMap, query.wipTo) ||
                                  "Assigned"}
                              </span>
                              <span className="flex items-center gap-1 text-[12px] font-semibold tabular-nums">
                                <AccessTimeOutlinedIcon className="!w-4 !h-4 shrink-0" />
                                {getWipTimer(query.wipAt)}
                              </span>
                              {!query.reassignDone && showReassignButton && (
                                <div
                                  className="relative shrink-0 w-[117px]"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <button
                                    type="button"
                                    className={`h-10 w-full border border-[#017C57] bg-transparent px-4 flex items-center justify-center gap-2 text-[12px] font-medium text-[#191919] border-solid ${
                                      reassignOpenId === query.id
                                        ? shouldOpenUp
                                          ? "rounded-b-[24px] rounded-t-none border-t-0"
                                          : "rounded-t-[24px] rounded-b-none border-b-0"
                                        : "rounded-[24px]"
                                    }`}
                                    onClick={(e) =>
                                      handleReassignClick(query, e)
                                    }
                                  >
                                    <span>RE - ASSIGN</span>
                                    {reassignOpenId === query.id ? (
                                      <KeyboardArrowUpIcon className="!w-5 !h-5 text-[#191919]" />
                                    ) : (
                                      <KeyboardArrowDownIcon className="!w-5 !h-5 text-[#191919]" />
                                    )}
                                  </button>

                                  {reassignOpenId === query.id && (
                                    <div
                                      className={`absolute left-0 w-full bg-white z-50 ${
                                        shouldOpenUp
                                          ? "bottom-full"
                                          : "top-full"
                                      }`}
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      {reassignLoadingId === query.id ? (
                                        <div className="p-3 text-center">
                                          <CircularProgress size={18} />
                                        </div>
                                      ) : (
                                        <Select
                                          autoFocus
                                          menuIsOpen
                                          isSearchable
                                          tabSelectsValue
                                          controlShouldRenderValue={false}
                                          menuPlacement={
                                            shouldOpenUp ? "top" : "bottom"
                                          }
                                          placeholder="Search"
                                          onKeyDown={(e) => {
                                            const currentInput =
                                              e?.target?.value || "";
                                            if (
                                              e.key === " " &&
                                              String(currentInput).trim()
                                                .length === 0
                                            ) {
                                              e.preventDefault();
                                              e.stopPropagation();
                                            }
                                          }}
                                          components={{
                                            DropdownIndicator: () => null,
                                          }}
                                          options={(
                                            reassignUsersByQueryId[query.id] ||
                                            []
                                          ).map((item) => ({
                                            label: getTeamUserDisplayName(item),
                                            value: String(
                                              item.userId ||
                                                item?.user?.id ||
                                                item.id,
                                            ),
                                            user: item,
                                          }))}
                                          onChange={(option) =>
                                            option?.user &&
                                            handleReassignUserPick(
                                              query,
                                              option.user,
                                            )
                                          }
                                          styles={{
                                            control: (base, state) => ({
                                              ...base,
                                              borderColor: "#017C57",
                                              borderLeft: "1px solid #017C57",
                                              borderRight: "1px solid #017C57",
                                              borderTop: "1px solid #017C57",
                                              borderBottom: "1px solid #017C57",
                                              borderRadius: 0,
                                              boxShadow: "none",
                                              outline: "none",
                                              "&:hover": {
                                                borderColor: "#017C57",
                                              },
                                            }),
                                            input: (base) => ({
                                              ...base,
                                              caretColor: "#017C57",
                                              color: "#191919",
                                            }),
                                            valueContainer: (base) => ({
                                              ...base,
                                              padding: "0 6px",
                                            }),
                                            indicatorsContainer: (base) => ({
                                              ...base,
                                              height: "32px",
                                            }),
                                            menu: (base) => ({
                                              ...base,
                                              border: "1px solid #017C57",
                                              boxShadow: "none",
                                              width: "100%",
                                              fontSize: "12px",
                                              zIndex: 9999,
                                              marginTop: 0,
                                              marginBottom: 0,
                                              borderWidth: "1px", // add this
                                              border: "1px solid #017C57",
                                              borderTop: shouldOpenUp
                                                ? "1px solid #017C57"
                                                : "0",
                                              borderBottom: shouldOpenUp
                                                ? "0"
                                                : "1px solid #017C57",
                                              borderRadius: shouldOpenUp
                                                ? "22px 22px 0 0"
                                                : "0 0 22px 22px",
                                              boxShadow: "none",
                                              overflow: "hidden",
                                            }),
                                            option: (base, state) => ({
                                              ...base,
                                              textAlign: "center",
                                              padding: "6px",
                                              whiteSpace: "normal",
                                              wordBreak: "break-word",
                                              backgroundColor: state.isFocused
                                                ? "#E8F5F0"
                                                : "#fff",
                                              color: "#191919",
                                              cursor: "pointer",
                                              ":active": {
                                                backgroundColor: state.isFocused
                                                  ? "#E8F5F0"
                                                  : "#fff",
                                              },
                                              ":hover": {
                                                backgroundColor: state.isFocused
                                                  ? "#E8F5F0"
                                                  : "#fff",
                                              },
                                            }),
                                            menuList: (base) => ({
                                              ...base,
                                              maxHeight: "150px",
                                              overflowY: "auto",
                                              overflowX: "hidden",
                                              scrollbarWidth: "none",
                                              msOverflowStyle: "none",
                                              "::-webkit-scrollbar": {
                                                display: "none",
                                              },
                                              padding: 0,
                                              borderRadius: shouldOpenUp
                                                ? "22px 22px 0 0"
                                                : "0 0 22px 22px",
                                            }),
                                            indicatorSeparator: () => ({
                                              display: "none",
                                            }),
                                          }}
                                        />
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          )}
                        </div>

                        <div
                          className={
                            hideData
                              ? "leading-[18px] whitespace-nowrap blur-[10px]"
                              : "leading-[18px] whitespace-nowrap"
                          }
                        >
                          {formatDateTime(query.tmsStageUpdateTime)}
                          {/* <div>
                          {formatDateTime(query.registeredDate)?.split(" ")[1]}{" "}
                          {formatDateTime(query.registeredDate)?.split(" ")[2]}
                        </div> */}

                          {/* <div>
                          {formatDateTime(query.registeredDate)?.split(" ")[0]}
                        </div> */}
                        </div>
                        <div className={hideData ? "blur-[10px]" : ""}>
                          {/* { getRemainingDays(query.resolveTatTime)} */}
                          {query?.case?.currentSubMasterStage?.commandCenterStage
                            ?.toLowerCase()
                            ?.includes("claim") ? (
                            new Date(query?.resolveTatTime)?.toLocaleDateString(
                              "en-IN",
                              {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              },
                            ) || "--"
                          ) : query?.resolveTatTime ? (
                            <CountdownTimer
                              targetDate={query?.resolveTatTime}
                            />
                          ) : (
                            "--"
                          )}
                        </div>

                        <div className={hideData ? "blur-[10px]" : ""}>
                          {!hideData && query.wipTo
                            ? query.doctorName ||
                              getNameByUserId(usersMap, query.wipTo) ||
                              "Assigned"
                            : "---"}
                        </div>

                        <div
                          className={
                            hideData
                              ? "flex items-center justify-center gap-2 blur-[10px] pointer-events-none"
                              : "flex items-center justify-center gap-2"
                          }
                        >
                          <button
                            className="h-10 px-3 border border-[#017C57] text-[#017C57] rounded-full bg-transparent flex items-center gap-1 border-solid"
                            onClick={() => handleForwardDoctorClick(query)}
                            title="Forward to Doctor"
                          >
                            <DoubleForwardArrow className="w-4 h-4" />
                            <NurseIcon className="w-4 h-4" />
                          </button>

                          <button
                            className="h-10 px-3 border border-[#017C57] text-[#000] rounded-full bg-transparent flex items-center gap-1 border-solid"
                            onClick={() => handleProceedClick(query)}
                            title="Open Query"
                          >
                            OPEN
                            <ArrowForwardIcon className="w-3 h-3" />
                          </button>

                          <img
                            src={DeleteIcon}
                            alt="delete-icon"
                            className="w-4 h-4 cursor-pointer"
                            onClick={() => handleDelete(query.id)}
                            title="Delete Query"
                          />
                        </div>
                      </div>
                    );
                  })}

                  {selectedQuery && (
                    <div
                      className="fixed top-0 right-0 h-screen w-screen flex justify-center items-center bg-[#017C5780] z-[1203]"
                      onClick={handleCloseQueryModal}
                    >
                      <div
                        className="relative w-[95%] h-[95%] rounded-[32px] bg-white p-6 overflow-hidden flex flex-col gap-6"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <TmsQueries
                          caseId={caseId}
                          setEditStatus={setSelectedQuery}
                          fetchQueries={fetchQueries}
                          fetchCaseQueryCounts={fetchCaseQueryCounts}
                          onCloseModal={handleCloseQueryModal}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </section>
            ) : (
              <div className="w-full flex justify-center items-center  font-semibold mt-8">
                No active Records found
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="flex justify-center mt-4">
        <CustomPagination
          page={page}
          setPage={setPage}
          totalPages={totalPages}
        />
      </div>

      <QueryForwardDoctorModal
        open={isForwardDoctorOpen && !!forwardQueryId}
        queryId={forwardQueryId}
        fetchQueries={fetchQueries}
        fetchCaseQueryCounts={fetchCaseQueryCounts}
        onClose={() => {
          setIsForwardDoctorOpen(false);
          setForwardQueryId(null);
        }}
      />
    </div>
  );
}

export default Managequery;
